// extracted by mini-css-extract-plugin
var _1 = "UploadingSpinnerStyle-module__lds-ring___ypjXA";
var _2 = "UploadingSpinnerStyle-module__lds-ring___ypjXA";
export { _1 as "lds-ring", _2 as "ldsRing" }
